/**
 * Return a new array of key strings
 *
 * @param {Object} filters - filter items
 * @returns {Array} Returns - Array containing list of keys
 *
 * Example usage:
 * const filterKeys = getFilterKeys(this.props.filters);
 * const activeFiltersKeys = getFilterKeys(this.props.activeFilters);
 *
 */
export default function getFilterKeys(filters = []) {
    const filterKeys = [];

    filters.map(key => filterKeys.push(key.queryParam));

    return filterKeys;
}



// WEBPACK FOOTER //
// ./src/components/filtered-listing/utils/filters/filter-helpers.js